/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { StructuredJobProgressDto } from "./StructuredJobProgressDto";

export const PublicJobDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type PublicJobDtoStatusEnumKey = (typeof PublicJobDtoStatusEnum)[keyof typeof PublicJobDtoStatusEnum];

export type PublicJobDto = {
    /**
     * @description Unique identifier of the job
     * @type string
    */
    id: string;
    /**
     * @description Current status of the job
     * @type string
    */
    status: PublicJobDtoStatusEnumKey;
    /**
     * @description Whether the job is still pending (scheduled, waiting, or in progress)
     * @type boolean
    */
    isPending: boolean;
    /**
     * @description Whether the job has finished (completed, failed, or cancelled)
     * @type boolean
    */
    isFinished: boolean;
    /**
     * @description Progress data of the job
     * @type object | undefined
    */
    progress?: object;
    /**
     * @description Timestamp when the progress was last updated
     * @type string | undefined
    */
    progressUpdatedAt?: string;
    /**
     * @description Progress percent (extracted from progress field)
     * @type number | undefined
    */
    progressPercent?: number;
    /**
     * @description Additional progress data (when progress is an object)
    */
    progressData?: StructuredJobProgressDto;
    /**
     * @description Timestamp when the job was processed
     * @type string
    */
    processedOn: string;
    /**
     * @description Timestamp when the job was finished (completed, failed, or cancelled)
     * @type string | undefined
    */
    finishedOn?: string;
};